import React, { FunctionComponent as FC, ReactElement as RE } from 'react';
import Map from '../../../data/google-maps/map';
import { IMapOptions } from '../../../data/google-maps/map.types';
import useGoogleMapsScript from '../../hooks/use-init-google-maps-script/useInitGoogleMapsScript';
import { fullSizecontainer } from './Maps.styles';

const MAP_DIV_ID = 'mapsToRender';

interface Props {
  mapsDivId?: string;
  mapOptions?: IMapOptions;
  inputId?: string;
  handleSelectAddress?: any;
  bounds?: any

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  children?: any;
  shellStyles?: Record<string, string>;

  GOOGLE_MAP_KEY: string;

  libraries?: string[];
}

const Maps: FC<Props> = ({
  children,
  shellStyles = fullSizecontainer,
  mapsDivId = MAP_DIV_ID,
  mapOptions = {},
  GOOGLE_MAP_KEY,
  inputId,
  handleSelectAddress,
  bounds,
  libraries,
}): RE => {
  useGoogleMapsScript({ GOOGLE_MAP_KEY, libraries });

  const mapWatcher = setInterval(() => {
    if (window?.google && google?.maps && !Map.map) {
      clearInterval(mapWatcher);
      Map.initMap({
        mapsDivId,
        mapOptions,
        inputId,
        handleSelectAddress,
        bounds,
      });

      if (
        mapOptions?.jsonOptions?.loadFromJson &&
        !!mapOptions.jsonOptions.jsonFile
      ) {
        Map.loadFromJson(mapOptions.jsonOptions.jsonFile);
      }
    }
  }, 1000);

  return (
    <div id={MAP_DIV_ID} style={shellStyles}>
      {children}
    </div>
  );
};

export default Maps;
